import { Component, Vue } from 'vue-property-decorator';
import CommonConfirmDialog from '@/components/dialog/CommonConfirmDialog.vue';

@Component
export default class AiCodingDialogMixin extends Vue {
  protected handleRetrieveRecommendCodesSuccess(res: any, handleData: (data: any) => void, closeDialog: () => void) {
    if (!res.success) {
      return Promise.reject(res);
    } else if (res.data.status === 'NOT_MATCHED') { // NOT MATCHED
      closeDialog();
      this.showNoRecommendCodesDialog();
      return Promise.reject(res);
    }
    handleData(res.data);
    return Promise.resolve(res);
  }

  protected handleRetrieveRecommendCodesError(
    errMsg: string | undefined,
    errCode: number | undefined,
    closeDialog: () => void,
    afterRequestFail: (errMsg: string) => void) {
    if (errCode === 1129) { // 풀링 시간 초과
      closeDialog();
    }
    if (errCode === 1130) { // 필수 아이템 누락
      this.showMissingItemAiCodingConfirmDialog(errMsg || '');
    } else if (errMsg) {
      afterRequestFail(errMsg);
    }
    return Promise.reject(errMsg);
  }

  protected showNoRecommendCodesDialog() {
    this.$modal.showCommonConfirmDialog({
      title: this.$t('message.noResultsAiCodingConfirmDialog.title').toString(),
      content: this.$t('message.noResultsAiCodingConfirmDialog.content').toString(),
      onConfirm: (context: CommonConfirmDialog) => {
        context.hide();
      },
      cancelVisible: false
    });
  }

  protected showMissingItemAiCodingConfirmDialog(errMsg: string) {
    this.$modal.showCommonConfirmDialog({
      title: this.$t('message.missingItemAiCodingConfirmDialog.title').toString(),
      content: '',
      htmlContent: this.$t('message.missingItemAiCodingConfirmDialog.content',
        {errMsg: `<li>${errMsg}</li>`}).toString(),
      onConfirm: (context: CommonConfirmDialog) => {
        context.hide();
      },
      cancelVisible: false
    });
  }
}
